import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import UsedCarValuation from "./component";
import { setIsSSR } from "../testimonial-carousel/actions";
import { fetchData } from "../../../components/shared/meta-tags/actions";
import { fetchFAQ } from "../why-cars/actions";

const mapStateToProps = ({
    meta: {
        genericContent,
        mainHeading,
        genericContent: {
            subHeading
        },
        seo,
        isSSR,
        faqList
    },
    footer: { data },
    customerReviews: { list }
}) => ({
    genericContent,
    data,
    mainHeading,
    subHeading,
    seo,
    isSSR,
    list,
    faqList
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setIsSSRConnect: setIsSSR,
    fetchDataConnect: fetchData,
    fetchFAQConnect: fetchFAQ
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UsedCarValuation);
